import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureName } from './company.state';
import { companyReducer } from './company.reducer';

@NgModule({
  imports: [StoreModule.forFeature(featureName, companyReducer)],
})
export class CompanyStoreModule {}
